var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container__content"},[_c('main-heading',{staticClass:"px-0 text-center",attrs:{"heading":"Formulario de inscripción"}}),_c('subscription-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }